// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  /* height: 100vh; */
  overflow-y: auto;
  /* background-color: red; */
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* Fluent UI overrides */
.ms-Label {
  font-weight: 600;
  margin-bottom: 8px;
}

.ms-TextField-fieldGroup {
  border-radius: 4px;
}

.ms-Button {
  border-radius: 4px;
}

/* Custom styles */
.email-info {
  background-color: #f3f2f1;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.email-info-item {
  margin-bottom: 8px;
}

.email-info-item strong {
  display: inline-block;
  width: 100px;
  color: #323130;
}

/* Message styles */
.success-message {
  color: #107c10;
  font-weight: 600;
}

.error-message {
  color: #a4262c;
  font-weight: 600;
}

.warning-message {
  color: #f7630c;
  font-weight: 600;
}

/* Button styles */
.action-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

/* Responsive */
@media (max-width: 400px) {
  .app-container {
    padding: 10px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-buttons button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".app-container {\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  /* height: 100vh; */\n  overflow-y: auto;\n  /* background-color: red; */\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n/* Fluent UI overrides */\n.ms-Label {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.ms-TextField-fieldGroup {\n  border-radius: 4px;\n}\n\n.ms-Button {\n  border-radius: 4px;\n}\n\n/* Custom styles */\n.email-info {\n  background-color: #f3f2f1;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n}\n\n.email-info-item {\n  margin-bottom: 8px;\n}\n\n.email-info-item strong {\n  display: inline-block;\n  width: 100px;\n  color: #323130;\n}\n\n/* Message styles */\n.success-message {\n  color: #107c10;\n  font-weight: 600;\n}\n\n.error-message {\n  color: #a4262c;\n  font-weight: 600;\n}\n\n.warning-message {\n  color: #f7630c;\n  font-weight: 600;\n}\n\n/* Button styles */\n.action-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n/* Responsive */\n@media (max-width: 400px) {\n  .app-container {\n    padding: 10px;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n  }\n\n  .action-buttons button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
